import { useMemo } from "react";

import { useUser } from "@accurx/concierge/hooks/data/useUser";
import {
    ItemCreatedByUser,
    NoteItem,
} from "@accurx/concierge/schemas/ConversationItemSchema";
import { getPreviewSummaryNote } from "domains/inbox/util/getPreviewSummaryNote";

import { PreviewSummaryTemplate } from "../../PreviewSummaryTemplate";

export type NoteProps = {
    conversationItem: NoteItem;
};

export const Note = ({ conversationItem }: NoteProps) => {
    const userId = (conversationItem.createdBy as ItemCreatedByUser).id;
    const participant = useUser({ userId });

    const summary = useMemo((): string => {
        const n = conversationItem.segments.find((segment) => {
            return segment.type === "Text";
        });

        if (n?.type !== "Text") return "";
        return `'${n.text}'`;
    }, [conversationItem.segments]);

    return (
        <PreviewSummaryTemplate
            note={getPreviewSummaryNote(participant)}
            messageSummary={`Note ${summary}`}
        />
    );
};
